import React from 'react';
import { Form, Select } from 'antd';
import { useQuery } from '@common/hooks';
import { ErrorHandler, Placeholder } from '@common/components';
import { ENUM_QUERY } from '@common/graphql';

export function YearsOfExperienceSelect({ hidden = false }) {
  const { loading, error, data } = useQuery(ENUM_QUERY, {
    variables: { key: 'YearsOfExperience' },
  });

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="YearsOfExperienceSelect"
        messageType="contextual"
      />
    );
  }

  return (
    <>
      <Placeholder.Input loading={loading} size="large">
        <Form.Item
          colon={false}
          label="Years of Experience"
          name="yearsOfExperience"
          hidden={hidden}
        >
          <Select
            className="YearsOfExperienceSelect"
            size="large"
            placeholder="Select the ideal years of experience"
            showSearch={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {data?.enum.map(
              ({
                name,
                description,
              }: {
                name: string;
                description: string;
              }) => {
                return (
                  <Select.Option key={name} value={name} title={description}>
                    {description}
                  </Select.Option>
                );
              }
            )}
          </Select>
        </Form.Item>
      </Placeholder.Input>

      <style jsx>
        {`
          :global(
            .YearsOfExperienceSelect,
            .ant-skeleton,
            .ant-skeleton-element .ant-skeleton-input-lg
          ) {
            width: 100%;
          }
        `}
      </style>
    </>
  );
}
